/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type UpdateMobileAppKanbanInput = {
    columns: Record<string, any>;
    id: string;
};
export type MobileAppMutationVariables = {
    input: UpdateMobileAppKanbanInput;
};
export type MobileAppMutationResponse = {
    readonly updateMobileAppKanban: {
        readonly mobileAppKanban: {
            readonly id: string;
            readonly columns: Record<string, any>;
        };
    };
};
export type MobileAppMutation = {
    readonly response: MobileAppMutationResponse;
    readonly variables: MobileAppMutationVariables;
};



/*
mutation MobileAppMutation(
  $input: UpdateMobileAppKanbanInput!
) {
  updateMobileAppKanban(input: $input) {
    mobileAppKanban {
      id
      columns
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateMobileAppKanbanPayload",
    "kind": "LinkedField",
    "name": "updateMobileAppKanban",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MobileAppKanban",
        "kind": "LinkedField",
        "name": "mobileAppKanban",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "columns",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MobileAppMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MobileAppMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "90a5a0aee67a429ca98cdc5884563da1",
    "id": null,
    "metadata": {},
    "name": "MobileAppMutation",
    "operationKind": "mutation",
    "text": "mutation MobileAppMutation(\n  $input: UpdateMobileAppKanbanInput!\n) {\n  updateMobileAppKanban(input: $input) {\n    mobileAppKanban {\n      id\n      columns\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'ccc39eecee2df140419e926e402cb104';
export default node;
